import type { ReactNode } from 'react';
import { useSelector } from 'react-redux';
import type { THistory } from '@timeedit/types/lib/types';
import { Modal, theme } from '@timeedit/ui-components/antd';
import intl from '../../i18n/intl';
import { userSelector } from '../../slices/user.slice';
import { timeConverter } from '../../utils/timeConverter';
import ActionButton from '../Buttons';
import './index.scss';

type Props = {
  listChoice?: string;
  listChoiceHeading?: string;
  modifiedDate?: number | null | string;
  modifiedBy?: string | undefined;
  changeHandler?: any;
  discardHandler?: any;
  displayProp: boolean;
  history: Array<THistory> | boolean | undefined;
  error?: any;
  isDisabled?: any;
  extra?: ReactNode;
};

const language: any = intl.messages;

const SectionHeader = ({
  listChoice,
  listChoiceHeading,
  modifiedDate,
  modifiedBy,
  changeHandler,
  discardHandler,
  displayProp,
  history,
  error,
  isDisabled,
  extra = undefined,
}: Props) => {
  const modifiedByUser = useSelector(userSelector(modifiedBy || ''));
  const { token } = theme.useToken();

  // Modal showing history of modified
  const HistoryModal = () => {
    Modal.info({
      title: `${language.modification_history}`,
      content: (
        <div style={{ maxHeight: 350, overflowY: 'scroll' }}>
          {typeof history === 'object' &&
            history.map((h: any) => (
              <p key={Math.random()}>
                <span style={{ fontWeight: 'bold' }}>
                  {timeConverter(h.modified)}
                </span>
                : {h.modifiedBy}
              </p>
            ))}
        </div>
      ),
      onOk() {},
    });
  };

  const classNames = ['section-header'];
  if (listChoice !== undefined) {
    classNames.push('not-visible');
  }

  return (
    <div className="section-header-wrapper">
      <div className="section-header-main">
        <div className={'header-text-wrapper'}>
          <h1
            style={{ marginTop: token.marginXS }}
            className={classNames.join(' ')}
          >
            {listChoiceHeading}
          </h1>
          <h4 style={{ marginBottom: 0 }}>{listChoice}</h4>
          {modifiedDate && (
            <p className={'modified-by-text'}>
              {typeof history === 'object' ? (
                <span className={'history-modal-button'} onClick={HistoryModal}>
                  {language.last_modified}:
                </span>
              ) : (
                <span>{language.last_modified}: </span>
              )}
              {modifiedDate} / {modifiedByUser?.username}
            </p>
          )}
        </div>
        <div
          className="header-right-bar--wrapper"
          style={{ alignItems: 'center' }}
        >
          {!(!changeHandler && !discardHandler) && (
            <div className="section-header-button-bar">
              <ActionButton
                title={language.save_changes}
                action={() => changeHandler}
                isDisabled={isDisabled === true}
                isDanger={false}
                displayProp={displayProp}
                isSaveChangesBtn
              />
              <ActionButton
                title={language.discard_changes}
                action={() => discardHandler}
                isDisabled={false}
                isDanger
                displayProp={displayProp}
              />
              {!!extra && extra}
            </div>
          )}
        </div>
      </div>
      <p
        style={{
          color: '#ff6357',
          background: 'white',
          margin: 0,
        }}
      >
        {error}
      </p>
    </div>
  );
};

export default SectionHeader;
